module.exports = __webpack_public_path__ + "img/slide11.33f6675f.png";